import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ebda441"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { key: 2 }

import {
  IonApp,
  IonContent,
  IonRow,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
  IonButton,
  menuController,
  onIonViewDidLeave,
} from "@ionic/vue";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { closeOutline } from "ionicons/icons";
import { useUserStore } from "./store/user.store";
import MenuProfileItem from "./components/MenuProfileItem.vue";
import { MENU_ITEMS } from "./utils/contants";
import MenuUserLoginItem from "./components/MenuUserLoginItem.vue";
import { presentToast } from "./utils/functions";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isLoading = ref(true);
const selectedFirstIndex = ref<number | null>(0);
const selectedSecondIndex = ref<number | null>(null);
const userStore = useUserStore();
const route = useRoute();
const router = useRouter();
const menu = MENU_ITEMS;
const authenicated = computed(() => userStore.authenticated);
const token = computed(() => userStore.token);

if (route?.path !== undefined) {
  selectedFirstIndex.value = menu.firstMenu.findIndex(
    (page) => page.url.toLowerCase() === route?.path.toLowerCase()
  );

  selectedSecondIndex.value = menu.secondMenu.findIndex(
    (page) => page.url.toLowerCase() === route?.path.toLowerCase()
  );
}

watch(selectedFirstIndex, (newVal) => {
  if (newVal === 0 || newVal) selectedSecondIndex.value = null;
});
watch(selectedSecondIndex, (newVal) => {
  if (newVal === 0 || newVal) selectedFirstIndex.value = null;
});

const onClose = () => {
  menuController.toggle();
};

const logout = () => {
  userStore.axLogout();
  presentToast("User logged out");
  router.push("/home");
};

onIonViewDidLeave(() => menuController.close("menu"));

onMounted(async () => {
  try {
    await userStore.axGetToken();
    const result = await userStore.axCheckToken(token?.value);
    isLoading.value = false;
    if (!result) {
      // await presentToast("Token is expired.");
    }
  } catch (error) {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading Application"))
        : _createCommentVNode("", true),
      (!isLoading.value && _unref(route)?.meta?.mode !== 'auth')
        ? (_openBlock(), _createBlock(_unref(IonSplitPane), {
            key: 1,
            "content-id": "main-content"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonMenu), {
                "content-id": "main-content",
                type: "overlay"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonContent), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), { class: "ion-justify-content-between ion-align-items-center user-wrapper" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            (authenicated.value)
                              ? (_openBlock(), _createBlock(MenuProfileItem, {
                                  key: 0,
                                  onOnClose: onClose
                                }))
                              : _createCommentVNode("", true),
                            (!authenicated.value)
                              ? (_openBlock(), _createBlock(MenuUserLoginItem, {
                                  key: 1,
                                  onOnClose: onClose
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_unref(IonMenuToggle), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonButton), {
                                fill: "clear",
                                class: "btn-close",
                                color: "dark"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    icon: _unref(closeOutline)
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonList), {
                        id: "inbox-list",
                        class: "first-menu-list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).firstMenu, (p, i) => {
                            return (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                              "auto-hide": false,
                              key: i
                            }, {
                              default: _withCtx(() => [
                                (!p.authRequired || authenicated.value)
                                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                                      key: 0,
                                      onClick: ($event: any) => (selectedFirstIndex.value = i),
                                      "router-direction": "root",
                                      "router-link": p.url,
                                      lines: "none",
                                      detail: false,
                                      class: _normalizeClass(["hydrated", { selected: selectedFirstIndex.value === i }])
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("i", {
                                          slot: "start",
                                          class: _normalizeClass('fa-duotone ' + p.icon)
                                        }, null, 2),
                                        (p.url === '/join-team' && authenicated.value)
                                          ? (_openBlock(), _createBlock(_unref(IonLabel), { key: 0 }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Join A Team")
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_unref(IonLabel), { key: 1 }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(p.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "router-link", "class"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _hoisted_3,
                      _createVNode(_unref(IonList), { id: "labels-list" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).secondMenu, (item, index) => {
                            return (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                              "auto-hide": false,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  onClick: ($event: any) => (selectedSecondIndex.value = index),
                                  "router-direction": "root",
                                  "router-link": item.url,
                                  lines: "none",
                                  detail: false,
                                  class: _normalizeClass(["hydrated", { selected: selectedSecondIndex.value === index }])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      slot: "start",
                                      class: _normalizeClass('fa-duotone ' + item.icon)
                                    }, null, 2),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _hoisted_4,
                      (authenicated.value)
                        ? (_openBlock(), _createBlock(_unref(IonList), {
                            key: 0,
                            id: "logout-list"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonMenuToggle), { "auto-hide": false }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonButton), {
                                        slot: "start",
                                        fill: "clear",
                                        onClick: logout
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonIcon), {
                                            slot: "start",
                                            src: require('@/assets/icons/logout.svg')
                                          }, null, 8, ["src"]),
                                          _createVNode(_unref(IonLabel), { class: "ion-text-uppercase" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Log out")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(IonRouterOutlet))
          ]))
    ]),
    _: 1
  }))
}
}

})